import { useQuery } from "@tanstack/react-query";
import { api } from "./client";
import type { Kit } from "./types";

// The detail endpoint returns the prototype Kit type plus the live stock count.
export type KitDetail = Kit & { stockQty: number };

export function useKit(id: string | undefined) {
  return useQuery<KitDetail | undefined>({
    queryKey: ["kit", id],
    queryFn: async () => {
      const { kit } = await api<{ kit: KitDetail }>(`/api/v1/catalogue/${id}`);
      return kit;
    },
    enabled: Boolean(id),
  });
}
